import React, { createContext, useState, useCallback, FC, useMemo } from 'react'
import { english } from '../../data/localizations'
import { LocalizationValues, LocalizedText } from './LocalizationTypes'

export interface LocalizationState {
    locale: string
    translations: LocalizationValues
    timezone: string
}

export interface LocalizationContextState {
    getTranslationText: (translation: LocalizedText) => string
}

const defaultState = {
    ...english,
    getTranslationText: (translation: LocalizedText) => '',
}

export const LocalizationContext = createContext(defaultState)
const { Provider, Consumer } = LocalizationContext

export function createTranslationsMap(translations: LocalizationValues): Map<LocalizedText, string> {
    const translationsMap = new Map()

    for(const [key, val] of Object.entries(translations)) {
        translationsMap.set(key, val)
    }

    return translationsMap
}

export interface LocalizationProviderProps {
    locale: string
    translations?: LocalizationValues
}
export const LocalizationProvider: FC<LocalizationProviderProps> = (props) => {
    const [locale, setLocale] = useState(english.locale)
    const [translationsMap] = useState(() => createTranslationsMap(props.translations || english.translations))

    const getTranslationText = useCallback((translation: LocalizedText) => {
        return translationsMap.get(translation) || `Translation Not Found`
    }, [translationsMap])

    const value = useMemo(() => ({
        ...english,
        translations: props.translations || english.translations,
        locale: props.locale || english.locale,
        getTranslationText,
    }), [
        getTranslationText,
        props.translations,
        props.locale,
        english.translations,
        english.locale,
    ])

    return (
        <Provider value={value}>
            {props.children}
        </Provider>
    )
}